// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-upload/es/index.js
// module id = 808
// module chunks = 0 1